import React, { useMemo, useState } from 'react';
import { FormField } from 'taboola-ultimate-ui';
import { BareDropdown } from 'taboola-ultimate-ui';
import { FormattedMessage } from '../../../../../../taboola-common-frontend-modules/i18n';
import { BID_STRATEGIES } from '../../../config';
import { BidControlCategory } from '../BidControlCategory/BidControlCategory';
import { useBidStrategyFormField } from '../hooks/useBidStrategyFormField';
import { BidAdjustmentMethodItem } from './components/BidAdjustmentMethodItem/BidAdjustmentMethodItem';
import { BidPercentModifier } from './components/BidPercentModifier/BidPercentModifier';
import { ADJUSTMENT_METHODS, useAdjustmentMethodOptions } from './hooks/useAdjustmentMethodOptions';
import styles from './bidAdjustmentMethod.module.scss';

const adjustmentMethodToComponent = {
    [ADJUSTMENT_METHODS.BID_CONTROL]: BidControlCategory,
    [ADJUSTMENT_METHODS.BID_MODIFIER]: BidPercentModifier,
};

const ValueRenderer = ({ data: { value, label } }) => (
    <FormattedMessage id={`campaign.editor.bid.adjustment.method.option.${value}`} defaultMessage={label} />
);

export const BidAdjustmentMethod = () => {
    const [adjustmentMethod, setAdjustmentMethod] = useState(null);
    const { onChange: onChangeBidStrategy } = useBidStrategyFormField();

    const AdjustmentMethodComponent = adjustmentMethodToComponent[adjustmentMethod];

    const handleAdjustmentMethodChange = selectedOption => {
        const newAdjustmentMethod = selectedOption.value;
        setAdjustmentMethod(newAdjustmentMethod);

        if (newAdjustmentMethod === ADJUSTMENT_METHODS.BID_MODIFIER) {
            onChangeBidStrategy(BID_STRATEGIES.BID_MODIFIER);
        } else if (newAdjustmentMethod === ADJUSTMENT_METHODS.BID_CONTROL) {
            onChangeBidStrategy(BID_STRATEGIES.SMART);
        }
    };

    const { dropdownOptions: adjustmentMethodOptions, selectedValue } = useAdjustmentMethodOptions({
        adjustmentMethod,
    });

    const dropdownStyle = useMemo(
        () => ({
            menuList: props => ({ ...props, padding: 0 }),
        }),
        []
    );

    return (
        <FormField
            containerClass={styles['container']}
            inputId="bid-adjustment-method"
            label={
                <FormattedMessage id="campaign.editor.bid.adjustment.method.title" defaultMessage="Adjustment Method" />
            }
            description={
                <FormattedMessage
                    id="campaign.editor.bid.adjustment.method.description"
                    defaultMessage="Set a new bid type/value or adjust the current value by a percentage."
                />
            }
            descriptionClass={styles['container-description']}
        >
            {adjustmentMethodOptions.length > 1 && (
                <BareDropdown
                    containerClassName={styles['dropdown-container']}
                    selectedValueObject={adjustmentMethod ? selectedValue : null}
                    options={adjustmentMethodOptions}
                    optionItemRenderer={BidAdjustmentMethodItem}
                    onChange={handleAdjustmentMethodChange}
                    valueRenderer={adjustmentMethod ? ValueRenderer : null}
                    placeholder={
                        <FormattedMessage
                            id="campaign.editor.bid.adjustment.method.placeholder"
                            defaultMessage="Select Adjustment Method"
                        />
                    }
                    styles={dropdownStyle}
                />
            )}
            {adjustmentMethod && <AdjustmentMethodComponent />}
        </FormField>
    );
};
